import {
  Grid,
  GridItem,
  Image,
  Box,
  Button,
  Flex,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  useDisclosure,
  ModalBody,
  ModalCloseButton,
  useToast,
  Switch,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Input,
  InputGroup,
  InputRightAddon,
  Textarea,
} from '@chakra-ui/react';
import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import PagosTable from './components/Pagos/pagosTable';
import GuiaTable from './components/guiaTable';
import dayjs from 'dayjs';
import { getStudentSchoolGroups } from 'utils/studentSchools';

import Collapsible from 'react-collapsible';

import xhr from 'xhr';
import HistorialTable from './components/historialTable';
import EnrollmentsTable from './components/enrollmentsTable';
import CareerTable from './components/careerTable';
import EmailsTable from './components/EmailsTable';
import AddStudentBadge from './components/AddStudentBadge';
import ExtraSubjects from './components/ExtraSubjects';
import useSWR from 'swr';
import { FaCaretDown, FaCaretRight, FaCheck } from 'react-icons/fa';
import getInfoStudent from 'api/administrador/student';
import Loading from 'components/loading/Loading';
import CourseTable from './components/courseTable';
import useAuth from 'hooks/useAuth';
import SmsTable from './components/SmsTable';
import ObservadorTable from './components/observador';
import StudentAbsencesModal from './components/StudentAbsencesModal';
import UpdateMonthsModal from './components/Pagos/UpdateMonthsModal';
import ReferralsTab from 'components/referrals/ReferralsTab';
import StudentRequestsTab from 'components/document-requests/StudentRequestsTab';
import StudentSummaryModal from 'components/student-summary/StudentSummaryModal';
import TranscriptModal from './components/TranscriptModal';

function VerEstudiante() {
  const [loading, setLoading] = React.useState(false);

  const [adviserFetching, setAdviserFetching] = React.useState(false);

  const [show, setShow] = React.useState(false);

  const [currentProgram, setCurrentProgram] = React.useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenBlackModal, onOpen: onOpenBlackModal, onClose: onCloseBlackModal } = useDisclosure(); // Modal motivo lista negra

  const { isOpen: isAbsOpen, onOpen: onAbsOpen, onClose: onAbsClose } = useDisclosure();
  const { isOpen: isSummaryOpen, onOpen: onSummaryOpen, onClose: onSummaryClose } = useDisclosure(); // Resumen de matrícula

  const [absFilters, setAbsFilters] = React.useState({
    gradeId: null,
    programTypeId: null,
    programTypeSlug: null,
    programName: '',
  });

  const openAbsences = (programType, program) => {
    setAbsFilters({
      gradeId: program?.id || null,
      programTypeId: programType?.id || null,
      programTypeSlug: programType?.slug || null,
      programName: `${programType?.name || ''} - ${program?.name || ''}`.trim(),
    });

    onAbsOpen();
  };

  const [blackReason, setBlackReason] = React.useState('');
  const [savingBlack, setSavingBlack] = React.useState(false);

  const [isOpenModal, setIsOpenModal] = React.useState(false);
  let params = useParams();
  const id_est = params.id;
  const toasts = useToast();
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();

  const openPaymentMonths = searchParams.get('open') === 'payment-months';
  const paymentMonthsProgramType = searchParams.get('programType') || '';
  const paymentMonthsProgram = searchParams.get('program') || '';
  const paymentMonthsEnrollment = searchParams.get('enrollment') || '';
  const paymentMonthsSemester = searchParams.get('semester') || '';
  const isUpdateMonthsModalOpen = openPaymentMonths && paymentMonthsProgramType && paymentMonthsProgram;

  const closeUpdateMonthsModal = React.useCallback(() => {
    searchParams.delete('open');
    searchParams.delete('programType');
    searchParams.delete('program');
    searchParams.delete('enrollment');
    searchParams.delete('semester');
    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  const { data, mutate } = useSWR({ id_est, user: user, type: 'getInfoStudentAdmin' }, getInfoStudent, {
    revalidateOnFocus: false,
  });

  const [userFrom, setUserFrom] = React.useState('');

  const [isPhotoModalOpen, setIsPhotoModalOpen] = React.useState(false);
  const [newPhoto, setNewPhoto] = React.useState(null);
  const [photoPreview, setPhotoPreview] = React.useState(null);
  const [savingPhoto, setSavingPhoto] = React.useState(false);

  const handlePhotoSelect = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toasts({
        title: 'Debes seleccionar una imagen.',
        status: 'warning',
        position: 'bottom',
      });
      return;
    }

    setNewPhoto(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const handleSavePhoto = async () => {
    if (!newPhoto) {
      toasts({
        title: 'Selecciona una imagen.',
        status: 'warning',
        position: 'bottom',
      });
      return;
    }

    try {
      setSavingPhoto(true);

      const formData = new FormData();

      formData.append('files', newPhoto);
      formData.append('ref', 'plugin::users-permissions.user');
      formData.append('refId', estudiante.user.id);
      formData.append('field', 'image');

      await xhr('/upload', {
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      await mutate();

      setNewPhoto(null);
      setPhotoPreview(null);
      setIsPhotoModalOpen(false);

      toasts({
        title: 'La foto se actualizó correctamente.',
        status: 'success',
        position: 'bottom',
      });
    } catch (error) {
      console.error(error);

      toasts({
        title: 'No se pudo actualizar la foto.',
        status: 'error',
        position: 'bottom',
      });
    } finally {
      setSavingPhoto(false);
    }
  };

  const handleDeletePhoto = async () => {
    if (!estudiante.user.image?.id) {
      toasts({
        title: 'El estudiante no tiene una foto para eliminar.',
        status: 'warning',
        position: 'bottom',
      });
      return;
    }

    const confirmDelete = window.confirm(
      '¿Estás seguro de eliminar la foto del estudiante?'
    );

    if (!confirmDelete) return;

    try {
      setSavingPhoto(true);

      await xhr.delete(`/upload/files/${estudiante.user.image.id}`);

      await mutate();

      setNewPhoto(null);
      setPhotoPreview(null);
      setIsPhotoModalOpen(false);

      toasts({
        title: 'La foto se eliminó correctamente.',
        status: 'success',
        position: 'bottom',
      });
    } catch (error) {
      console.error('Error eliminando la foto:', error);

      toasts({
        title: 'No se pudo eliminar la foto.',
        status: 'error',
        position: 'bottom',
      });
    } finally {
      setSavingPhoto(false);
    }
  };

  const handleSimat = async () => {
    try {
      setLoading(true);

      await xhr.put(`/students/${id_est}`, {
        data: {
          simat: data.estudiante?.simat,
        },
      });

      toasts({
        title: 'El simat se actualizó correctamente!',
        position: 'bottom',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDesease = async () => {
    try {
      setLoading(true);

      await xhr.put(`/students/${id_est}`, {
        data: {
          desease: data.estudiante?.desease,
        },
      });

      toasts({
        title: 'Datos actualizados correctamente!',
        position: 'bottom',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSchool = async () => {
    try {
      setLoading(true);

      await xhr.put(`/students/${id_est}`, {
        data: {
          school: data.estudiante?.school,
        },
      });

      toasts({
        title: 'El colegio se actualizó correctamente!',
        position: 'bottom',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdviser = async () => {
    try {
      setAdviserFetching(true);
      await xhr.put(`/students/${id_est}`, {
        data: { adviser: data.estudiante?.adviser?.id },
      });
      toasts({
        title: 'La información se actualizó correctamente!',
        position: 'bottom',
      });
    } catch (error) {
    } finally {
      setAdviserFetching(false);
    }
  };

  const handleBanStudent = (bool) => {
    let letra = '';
    let tof = null;

    if (bool === false) {
      letra = 'activar';
      tof = true;
    } else {
      letra = 'desactivar';

      tof = false;
    }

    const r = window.confirm(`¿Estás seguro de ${letra} a este estudiante?`);

    if (r) banStudent(tof);
  };

  const handleBlackStudent = (bool) => {
    if (!bool) {
      setBlackReason(estudiante.black_list_description || '');
      onOpenBlackModal();
    } else {
      const r = window.confirm('¿Estás seguro de quitar a este estudiante de la lista negra?');
      if (r) blackStudent(false, null);
    }
  };

  const blackStudent = async (tof, reason = null) => {
    const payload = { black_list: tof };
    if (tof) {
      payload.black_list_description = (reason || '').trim();
    } else {
      payload.black_list_description = null;
    }

    const responseBan = await xhr.put(`/students/${id_est}`, { data: payload });

    mutate(
      {
        ...data,
        estudiante: {
          ...estudiante,
          black_list: responseBan.data.data.black_list,
          black_list_description: responseBan.data.data.black_list_description,
        },
      },
      false
    );

    toasts({
      title: 'El estudiante se modificó correctamente!',
      position: 'bottom',
    });
  };
  const banStudent = async (tof) => {
    const responseBan = await xhr.put(`/students/${id_est}`, {
      data: {
        active: tof,
      },
    });

    mutate(
      {
        ...data,
        estudiante: { ...estudiante, active: responseBan.data.data.active },
      },
      false
    );

    toasts({
      title: 'El estudiante se modificó correctamente!',
      position: 'bottom',
    });
  };


  const handleBoletin = async () => {
    try {
      setLoading(true);

      const response = await xhr.put(`/students/${id_est}`, {
        data: {
          boletin: estudiante?.boletin,
        },
      });

      mutate(
        {
          ...data,
          estudiante: {
            ...estudiante,
            boletin: response.data.data.boletin,
          },
        },
        false
      );

      toasts({
        title: 'El estado del boletín se actualizó correctamente!',
        position: 'bottom',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleLowPerformance = async () => {
    try {
      setLoading(true);

      const response = await xhr.put(`/students/${id_est}`, {
        data: {
          low_performance: estudiante?.low_performance,
        },
      });

      mutate(
        {
          ...data,
          estudiante: {
            ...estudiante,
            low_performance: response.data.data.low_performance,
          },
        },
        false
      );

      toasts({
        title: 'El estado de bajo rendimiento se actualizó correctamente!',
        position: 'bottom',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCategory = async () => {
    await xhr.put(`/students/${id_est}`, {
      data: {
        user_from: userFrom,
      },
    });
    mutate({ ...data, estudiante: { ...estudiante, user_from: userFrom } }, false);
    setShow(false);
  };

  if (!data) return <Loading />;

  if (data.error) return <Box>{data.error}</Box>;

  const { programTypes, affiliate, estudiante, advisers, badges } = data;
  const birthdate = estudiante.birthdate || estudiante.user?.birthdate;

  return (
    <>
      <Box
        boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 #574feb"
        padding="30px"
        borderRadius="5px"
        backgroundColor="white"
      >
        <text fontWeight="bold" fontSize="20px">
          {estudiante.user.first_name && (
            <>
              {estudiante.user.first_name.toUpperCase()}&nbsp;
              {estudiante.user.last_name.toUpperCase()}
            </>
          )}
        </text>

        <Text fontWeight="bold" fontSize="15px">
          {estudiante.black_list && (
            <Box bg="red.400" rounded={'10px'} p="10px">
              <b>ESTE ESTUDIANTE ESTÁ EN LA LISTA NEGRA:</b>
              {estudiante.black_list_description && (
                <Box mt="2">
                  <b>Motivo:</b> {estudiante.black_list_description}
                </Box>
              )}
            </Box>
          )}
        </Text>

        <hr />
        <Grid templateColumns="repeat(9, 1fr)" gap={5}>
          <GridItem colSpan={2}>
            <Box
              boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 #574feb"
              padding="10px"
              borderRadius="5px"
              backgroundColor="white"
              marginY="10px"
            >
              {estudiante.user.image ? (
                <Box
                  position="relative"
                  cursor="pointer"
                  marginBottom="20px"
                  onClick={() => {
                    setPhotoPreview(null);
                    setNewPhoto(null);
                    setIsPhotoModalOpen(true);
                  }}
                >
                  <Image
                    src={estudiante.user.image.url}
                    width="100%"
                    objectFit="cover"
                    height="150px"
                    borderRadius="10px"
                  />

                  <Box
                    position="absolute"
                    bottom="8px"
                    right="8px"
                    background="rgba(0,0,0,0.65)"
                    color="white"
                    paddingX="10px"
                    paddingY="5px"
                    borderRadius="6px"
                    fontSize="12px"
                  >
                    Ver / Editar
                  </Box>
                </Box>
              ) : (
                <Box
                  alignX="center"
                  marginBottom="20px"
                  cursor="pointer"
                  onClick={() => {
                    setPhotoPreview(null);
                    setNewPhoto(null);
                    setIsPhotoModalOpen(true);
                  }}
                >
                  <Flex
                    backgroundColor="#574feb"
                    width="140px"
                    height="140px"
                    borderRadius="50%"
                    justifyContent="center"
                    alignItems="center"
                    fontWeight="500"
                    fontSize="48px"
                    color="white"
                    margin="auto"
                  >
                    {estudiante.user.first_name?.[0] && (
                      <>
                        {estudiante.user.first_name[0].toUpperCase()}
                        {estudiante.user.last_name?.[0]?.toUpperCase()}
                      </>
                    )}
                  </Flex>

                  <Text
                    textAlign="center"
                    color="#574feb"
                    fontSize="12px"
                    fontWeight="500"
                    marginTop="5px"
                  >
                    Agregar foto
                  </Text>
                </Box>
              )}

              <Text marginTop="15px" fontSize="14px">
                Código: {id_est}
                <br />
                Email: {estudiante.user.email}
                {estudiante.desease ? (
                  <>
                    <br />
                    <span style={{ backgroundColor: 'red', padding: 3, color: 'white', borderRadius: 5 }}>
                      Condición del estudiante: {estudiante.desease}
                    </span>
                  </>
                ) : (
                  ''
                )}
                <br />
                <Box>
                  Afiliado:{' '}
                  <b>
                    {affiliate?.user?.first_name} {affiliate?.user?.last_name}{' '}
                  </b>
                </Box>
                <Box>
                  <Box
                    onClick={() => {
                      setShow(!show);
                      setUserFrom(estudiante?.user_from);
                    }}
                    cursor="pointer"
                  >
                    Categoría: {!show && estudiante.user_from}
                  </Box>
                  {show && (
                    <InputGroup size="xs">
                      <Input onChange={(e) => setUserFrom(e.target.value)} value={userFrom} />
                      <InputRightAddon onClick={() => handleCategory()} children={<FaCheck />} cursor="pointer" />
                    </InputGroup>
                  )}
                </Box>
                {estudiante.user?.country && (
                  <>
                    País: {estudiante.user?.country.name} <br />
                    Indicativo: +{estudiante.user?.country.phone_code}
                    <br />
                  </>
                )}
                Celular: {estudiante.user.cellphone}
                <br />
                SIMAT: <b>{!estudiante.simat ? 'No está matriculado' : estudiante.simat}</b>
                <br />
                Fecha Matricula: {dayjs(estudiante.user.createdAt).format('DD-MM-YYYY')}
                <br />
                Fecha Nacimiento: {birthdate && dayjs(birthdate).format('DD-MM-YYYY')}
                <br />
                Edad:{' '}
                {birthdate && dayjs(birthdate).isValid()
                  ? `${dayjs().diff(dayjs(birthdate), 'year')} años`
                  : 'N/A'}
                <br />
                {estudiante.last_approved_grade && (
                  <Box>
                    Último grado aprobado: <Box fontWeight="600">{estudiante.last_approved_grade}</Box>
                    <br />
                  </Box>
                )}
                {data.parent && (
                  <Box borderY="1px solid gray" marginTop="10px" paddingTop="10px" paddingBottom="0px">
                    <Text fontSize="15px" fontWeight="500">
                      Acudiente: {data.parent.full_name || `${data.parent.user?.first_name || ''} ${data.parent.user?.last_name || ''}`.trim()}
                    </Text>
                    <Box fontWeight="400">
                      Celular: {data.parent.home_phone || data.parent.user?.cellphone}
                      <br />
                      Email: {data.parent.email || data.parent.user?.email}
                    </Box>
                    <br />
                  </Box>
                )}
                {['admin', 'supervisor_admin'].includes(user?.role?.type) && (
                  <Button
                    colorScheme="#574feb"
                    borderColor="#574feb"
                    borderWidth="1px"
                    variant="outline"
                    onClick={() => handleBanStudent(estudiante.active)}
                    size="xs"
                    mt="10px"
                  >
                    {estudiante.active === false ? 'Activar' : 'Desactivar'}
                  </Button>
                )}
                {['admin', 'supervisor_admin'].includes(user.role.type) &&
                  (!estudiante.black_list ? (
                    <Button
                      colorScheme="#574feb"
                      borderColor="#574feb"
                      borderWidth="1px"
                      variant="outline"
                      onClick={() => handleBlackStudent(estudiante.black_list)}
                      size="xs"
                      mt="10px"
                    >
                      Agregar a la lista negra
                    </Button>
                  ) : (
                    <Button
                      colorScheme="#574feb"
                      borderColor="#574feb"
                      borderWidth="1px"
                      variant="outline"
                      onClick={() => handleBlackStudent(estudiante.black_list)}
                      size="xs"
                      mt="10px"
                    >
                      Quitar de la lista negra
                    </Button>
                  ))}
                <Box fontSize="17px" marginY="10px">
                  <Link to={`/plataforma/administrador/modificar-estudiante/${id_est}`}>
                    <Button colorScheme="#574feb" backgroundColor="#574feb" size="sm">
                      Actualizar Datos
                    </Button>
                  </Link>
                  <Button
                    colorScheme="#574feb"
                    borderColor="#574feb"
                    color="#574feb"
                    borderWidth="1px"
                    variant="outline"
                    size="sm"
                    ml="10px"
                    onClick={onSummaryOpen}
                  >
                    Resumen de matrícula
                  </Button>
                  <StudentSummaryModal studentId={id_est} isOpen={isSummaryOpen} onClose={onSummaryClose} />
                  <Link to={`/plataforma/administrador/ver-estudiante/${id_est}/ver-actividad`}>
                    <Button colorScheme="purple" size="xs" mt="10px">
                      Ver actividades
                    </Button>
                  </Link>
                  <Link to={`/plataforma/administrador/constancias-y-certificados/${id_est}`}>
                    <Button colorScheme="purple" size="xs" mt="10px" ml="10px">
                      Documentos
                    </Button>
                  </Link>

                  <TranscriptModal student={estudiante} idEst={id_est} />

                  {user?.school ? (
                    ''
                  ) : (
                    <>
                      <Box borderTop="1px solid gray" paddingY="10px" marginTop="10px">
                        <Box fontSize="14px" fontWeight="500">
                          Boletín
                        </Box>

                        <Flex align="center" justify="space-between" marginTop="10px">
                          <Text fontSize="13px" color="gray.600">
                            {estudiante?.boletin ? 'Activado' : 'Desactivado'}
                          </Text>

                          <Switch
                            colorScheme="green"
                            isChecked={Boolean(estudiante?.boletin)}
                            onChange={(e) =>
                              mutate(
                                {
                                  ...data,
                                  estudiante: {
                                    ...estudiante,
                                    boletin: e.target.checked,
                                  },
                                },
                                false
                              )
                            }
                          />
                        </Flex>

                        <Button
                          colorScheme="#574feb"
                          borderWidth="1px"
                          borderColor="#574feb"
                          size="sm"
                          variant="outline"
                          marginTop="10px"
                          isLoading={loading}
                          onClick={handleBoletin}
                        >
                          Actualizar
                        </Button>
                      </Box>

                      <Box borderTop="1px solid gray" paddingY="10px" marginTop="10px">
                        <Box fontSize="14px" fontWeight="500">
                          Bajo rendimiento
                        </Box>

                        <Flex align="center" justify="space-between" marginTop="10px">
                          <Text fontSize="13px" color="gray.600">
                            {estudiante?.low_performance ? 'Activado' : 'Desactivado'}
                          </Text>

                          <Switch
                            colorScheme="red"
                            isChecked={Boolean(estudiante?.low_performance)}
                            onChange={(e) =>
                              mutate(
                                {
                                  ...data,
                                  estudiante: {
                                    ...estudiante,
                                    low_performance: e.target.checked,
                                  },
                                },
                                false
                              )
                            }
                          />
                        </Flex>

                        <Button
                          colorScheme="#574feb"
                          borderWidth="1px"
                          borderColor="#574feb"
                          size="sm"
                          variant="outline"
                          marginTop="10px"
                          isLoading={loading}
                          onClick={handleLowPerformance}
                        >
                          Actualizar
                        </Button>
                      </Box>

                      <Box borderTop="1px solid gray" paddingY="10px" marginTop="10px">
                        <Box fontSize="14px" fontWeight="500">
                          Asesora
                        </Box>

                        <Select
                          value={estudiante?.adviser?.id}
                          marginTop="10px"
                          placeholder="Seleccionar"
                          onChange={(e) =>
                            mutate(
                              {
                                ...data,
                                estudiante: {
                                  ...estudiante,
                                  adviser: { id: Number(e.target.value) },
                                },
                              },
                              false
                            )
                          }
                        >
                          {advisers.map((el) => {
                            return (
                              <option value={el.value} key={el.label}>
                                {el.label}
                              </option>
                            );
                          })}
                        </Select>

                        <Button
                          colorScheme="#574feb"
                          borderWidth="1px"
                          borderColor="#574feb"
                          size="sm"
                          variant="outline"
                          marginTop="10px"
                          isLoading={adviserFetching}
                          onClick={handleAdviser}
                        >
                          Actualizar
                        </Button>
                      </Box>

                      <Box
                        borderTop="1px solid gray"
                        borderBottom="1px solid gray"
                        paddingBottom="15px"
                        paddingTop="10px"
                        marginTop="10px"
                      >
                        <Box fontSize="14px" fontWeight="500">
                          Colegio
                        </Box>

                        <Select
                          value={estudiante.school}
                          marginTop="10px"
                          placeholder="Seleccionar"
                          onChange={(e) =>
                            mutate(
                              {
                                ...data,
                                estudiante: {
                                  ...estudiante,
                                  school: e.target.value,
                                },
                              },
                              false
                            )
                          }
                        >
                          {getStudentSchoolGroups(estudiante.school).map(group => (
                            <optgroup key={group.label} label={group.label}>
                              {group.options.map(option => (
                                <option key={option.value} value={option.value} disabled={option.disabled}>{option.label}</option>
                              ))}
                            </optgroup>
                          ))}
                        </Select>

                        <Button
                          colorScheme="#574feb"
                          borderWidth="1px"
                          borderColor="#574feb"
                          size="sm"
                          variant="outline"
                          marginY="10px"
                          isLoading={loading}
                          onClick={handleSchool}
                        >
                          Actualizar
                        </Button>
                      </Box>

                      <Box borderBottom="1px solid gray" paddingBottom="15px" paddingTop="10px" marginTop="10px">
                        <Box fontSize="14px" fontWeight="500">
                          Estado del SIMAT
                        </Box>

                        <Select
                          value={estudiante.simat}
                          marginTop="10px"
                          placeholder="Seleccionar"
                          onChange={(e) =>
                            mutate(
                              {
                                ...data,
                                estudiante: {
                                  ...estudiante,
                                  simat: e.target.value,
                                },
                              },
                              false
                            )
                          }
                        >
                          <option value="pendiente">Pendiente</option>
                          <option value="matriculado">Matriculado</option>
                          <option value="retirado">Retirado</option>
                          <option value="pendiente_retiro">Pendiente Retiro</option>
                        </Select>

                        <Button
                          colorScheme="#574feb"
                          borderWidth="1px"
                          borderColor="#574feb"
                          size="sm"
                          variant="outline"
                          marginY="10px"
                          isLoading={loading}
                          onClick={handleSimat}
                        >
                          Actualizar
                        </Button>
                      </Box>

                      <Box borderBottom="1px solid gray" paddingBottom="15px" paddingTop="10px" marginTop="10px">
                        <Box fontSize="14px" fontWeight="500">
                          Condición
                        </Box>

                        <Input
                          value={estudiante.desease}
                          marginTop="10px"
                          placeholder="Condición"
                          onChange={(e) =>
                            mutate(
                              {
                                ...data,
                                estudiante: {
                                  ...estudiante,
                                  desease: e.target.value,
                                },
                              },
                              false
                            )
                          }
                        />

                        <Button
                          colorScheme="#574feb"
                          borderWidth="1px"
                          borderColor="#574feb"
                          size="sm"
                          variant="outline"
                          marginY="10px"
                          isLoading={loading}
                          onClick={handleDesease}
                        >
                          Actualizar
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
              </Text>

              {user?.school ? (
                ''
              ) : (
                <Box marginTop="10px">
                  <Box fontSize="14px" fontWeight="500">
                    Insignias
                  </Box>

                  <Flex marginTop="10px" flexWrap="wrap">
                    {badges.map((el, i) => {
                      if (!el.badge) return null;

                      return (
                        <a
                          target="_blank"
                          cursor="pointer"
                          href={`/plataforma/publico/insignias/${el.id}`}
                          rel="noreferrer"
                        >
                          <Image src={el.badge.image?.url} width="60px" marginRight="15px" />
                        </a>
                      );
                    })}
                  </Flex>

                  <AddStudentBadge
                    student={estudiante}
                    studentBadges={badges}
                    mutate={mutate}
                    dataAll={data}
                    isOpenModal={isOpenModal}
                    setIsOpenModal={setIsOpenModal}
                  />

                  <Button
                    colorScheme="#574feb"
                    borderWidth="1px"
                    borderColor="#574feb"
                    size="sm"
                    variant="outline"
                    marginY="10px"
                    onClick={() => setIsOpenModal(true)}
                  >
                    Agregar Insignia
                  </Button>
                </Box>
              )}
            </Box>
          </GridItem>

          <GridItem colSpan={7}>
            <Grid>
              <GridItem colSpan={12}>
                <Box
                  boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 #574feb"
                  padding="10px"
                  borderRadius="5px"
                  backgroundColor="white"
                  marginY="10px"
                >
                  <Text fontWeight="500">Programas</Text>
                  <Box maxHeight="300px" overflowY="scroll">
                    {programTypes.map((programType) => {
                      const unique = programType.programs.filter(
                        (el, index, self) => self.findIndex((v) => v.id === el.id) === index
                      );
                      return (
                        <>
                          <Box paddingY="10px" paddingX="10px" key={programType.id}>
                            <Collapsible
                              trigger={
                                <>
                                  <Box
                                    cursor="pointer"
                                    textAlign="left"
                                    marginTop="5px"
                                    background="white"
                                    border="1px solid #3272F1"
                                    padding="10px"
                                    borderRadius="10px"
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    &nbsp;{programType.name}
                                    <FaCaretDown color="3272F1" />
                                  </Box>
                                </>
                              }
                            >
                              {unique.map((program) => {
                                return (
                                  <>
                                    <Collapsible
                                      key={program.id}
                                      trigger={
                                        <Flex
                                          background="white"
                                          marginLeft="30px"
                                          border="1px solid #3272F1"
                                          borderRadius="10px"
                                          marginTop="10px"
                                          marginBottom="10px"
                                          alignItems="center"
                                          justifyContent="space-between"
                                        >
                                          <Box
                                            cursor="pointer"
                                            padding="10px"
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                            &nbsp;{program.name}
                                            <FaCaretDown />
                                          </Box>
                                        </Flex>
                                      }
                                    >
                                      <Box textAlign="left" paddingLeft="60px">
                                        <Link
                                          to={`/plataforma/administrador/ver-resultados/${programType.slug}/${program.slug}?id=${id_est}`}
                                        >
                                          <Box
                                            border="1px solid #3272F1"
                                            borderRadius="10px"
                                            paddingLeft="10px"
                                            paddingRight="10px"
                                            marginBottom="10px"
                                            cursor="pointer"
                                            display="flex"
                                            alignItems="center"
                                          >
                                            Notas
                                            <FaCaretRight />
                                          </Box>
                                        </Link>

                                        {user?.school ? (
                                          ''
                                        ) : (
                                          <Box
                                            onClick={() => {
                                              setCurrentProgram({
                                                ...program,
                                                program_type: programType,
                                              });
                                              onOpen();
                                            }}
                                            border="1px solid #3272F1"
                                            borderRadius="10px"
                                            cursor="pointer"
                                          >
                                            <Box
                                              paddingLeft="10px"
                                              paddingRight="10px"
                                              display="flex"
                                              alignItems="center"
                                            >
                                              Materias extras
                                              <FaCaretRight />
                                            </Box>
                                          </Box>
                                        )}

                                        <Link
                                          to={`/plataforma/administrador/ver-estudiante/${id_est}/ver-requisitos?program=${program.id}&programType=${programType.id}&type=${programType?.type}`}
                                        >
                                          <Box
                                            border="1px solid #3272F1"
                                            borderRadius="10px"
                                            paddingLeft="10px"
                                            paddingRight="10px"
                                            marginBottom="10px"
                                            cursor="pointer"
                                            display="flex"
                                            alignItems="center"
                                            mt="10px"
                                          >
                                            &nbsp;Requisitos
                                            <FaCaretRight />
                                          </Box>
                                        </Link>

                                        <Box
                                          onClick={() => openAbsences(programType, program)}
                                          border="1px solid #3272F1"
                                          borderRadius="10px"
                                          paddingLeft="10px"
                                          paddingRight="10px"
                                          marginBottom="10px"
                                          cursor="pointer"
                                          display="flex"
                                          alignItems="center"
                                          mt="10px"
                                        >
                                          Inasistencias
                                          <FaCaretRight />
                                        </Box>
                                      </Box>
                                    </Collapsible>
                                  </>
                                );
                              })}
                            </Collapsible>
                          </Box>
                          <hr />
                        </>
                      );
                    })}
                  </Box>
                </Box>

                {!programTypes[0] && <Box padding="20px">este estudiante no tiene programas matriculados</Box>}
              </GridItem>
            </Grid>

            <Modal isOpen={isOpen} onClose={onClose} size="3xl">
              <ModalOverlay />
              <ModalContent>
                <ModalCloseButton />
                <ModalBody>
                  <ExtraSubjects currentProgram={currentProgram} studentId={id_est} />
                </ModalBody>
              </ModalContent>
            </Modal>

            <Modal
              isOpen={isPhotoModalOpen}
              onClose={() => {
                setIsPhotoModalOpen(false);
                setNewPhoto(null);
                setPhotoPreview(null);
              }}
              size="lg"
              isCentered
            >
              <ModalOverlay />

              <ModalContent>
                <ModalCloseButton />

                <ModalBody padding="25px">
                  <Text fontWeight="bold" fontSize="lg" marginBottom="15px">
                    Foto del estudiante
                  </Text>

                  <Image
                    src={photoPreview || estudiante.user.image?.url}
                    width="100%"
                    maxHeight="450px"
                    objectFit="contain"
                    borderRadius="10px"
                    marginBottom="20px"
                  />

                  <Input
                    id="student-photo"
                    type="file"
                    accept="image/png,image/jpeg,image/jpg,image/webp"
                    display="none"
                    onChange={handlePhotoSelect}
                  />

                  <Flex
                    gap="10px"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                  >
                    <Box>
                      {estudiante.user.image?.id && (
                        <Button
                          colorScheme="red"
                          variant="outline"
                          onClick={handleDeletePhoto}
                          isLoading={savingPhoto}
                        >
                          Eliminar foto
                        </Button>
                      )}
                    </Box>

                    <Flex gap="10px">
                      <Button
                        as="label"
                        htmlFor="student-photo"
                        colorScheme="purple"
                        variant="outline"
                        cursor="pointer"
                        isDisabled={savingPhoto}
                      >
                        {estudiante.user.image ? 'Cambiar foto' : 'Seleccionar foto'}
                      </Button>

                      {newPhoto && (
                        <Button
                          backgroundColor="#574feb"
                          color="white"
                          isLoading={savingPhoto}
                          onClick={handleSavePhoto}
                          _hover={{ backgroundColor: '#463ec7' }}
                        >
                          Guardar foto
                        </Button>
                      )}
                    </Flex>
                  </Flex>
                </ModalBody>
              </ModalContent>
            </Modal>

            <Modal isOpen={isOpenBlackModal} onClose={onCloseBlackModal}>
              <ModalOverlay />
              <ModalContent p="4">
                <Text fontWeight="bold" fontSize="lg" mb="2">
                  Motivo para agregar a la lista negra
                </Text>
                <Textarea
                  placeholder="Describe la razón…"
                  value={blackReason}
                  onChange={(e) => setBlackReason(e.target.value)}
                  rows={5}
                />
                <Flex justify="flex-end" mt="4" gap="2">
                  <Button variant="outline" onClick={onCloseBlackModal}>
                    Cancelar
                  </Button>
                  <Button
                    colorScheme="purple"
                    isLoading={savingBlack}
                    onClick={async () => {
                      if (!blackReason.trim()) {
                        return toasts({ title: 'Debes ingresar la razón.', position: 'bottom' });
                      }
                      try {
                        setSavingBlack(true);
                        await blackStudent(true, blackReason);
                        onCloseBlackModal();
                      } catch (e) {
                        console.error(e);
                        toasts({ title: 'No se pudo guardar el motivo.', position: 'bottom' });
                      } finally {
                        setSavingBlack(false);
                      }
                    }}
                  >
                    Guardar
                  </Button>
                </Flex>
              </ModalContent>
            </Modal>

            <GridItem colSpan={12} marginTop="20px">
              <Tabs isLazy={true}>
                {user?.school ? (
                  <TabList>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Historial
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Pagos
                    </Tab>

                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Grados
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Carreras Técnicas
                    </Tab>
                  </TabList>
                ) : (
                  <TabList>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Observador
                    </Tab>

                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Historial
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Pagos
                    </Tab>

                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Emails
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Documentos
                    </Tab>

                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Nº Guía
                    </Tab>

                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Grados
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Carreras Técnicas
                    </Tab>

                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Cursos
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Referidos
                    </Tab>
                    <Tab
                      _focus={{ border: 0 }}
                      _selected={{
                        borderBottom: '2px solid #574feb',
                        fontWeight: 'bold',
                        color: '#574feb',
                      }}
                    >
                      Solicitudes
                    </Tab>
                  </TabList>
                )}
                {user?.school ? (
                  <TabPanels>
                    <TabPanel>
                      <HistorialTable />
                    </TabPanel>
                    <TabPanel>
                      <PagosTable programTypes={programTypes} advisers={advisers} />
                    </TabPanel>
                    <TabPanel>
                      <EnrollmentsTable />
                    </TabPanel>
                    <TabPanel>
                      <CareerTable />
                    </TabPanel>
                  </TabPanels>
                ) : (
                  <TabPanels>
                    <TabPanel>
                      <ObservadorTable />
                    </TabPanel>

                    <TabPanel>
                      <HistorialTable />
                    </TabPanel>
                    <TabPanel>
                      <PagosTable programTypes={programTypes} advisers={advisers} />
                    </TabPanel>

                    <TabPanel>
                      <EmailsTable />
                    </TabPanel>
                    <TabPanel>
                      <SmsTable cellphoneStudent={estudiante.user.cellphone} idStudent={estudiante.id} />
                    </TabPanel>
                    <TabPanel>
                      <GuiaTable />
                    </TabPanel>

                    <TabPanel>
                      <EnrollmentsTable />
                    </TabPanel>

                    <TabPanel>
                      <CareerTable />
                    </TabPanel>
                    <TabPanel>
                      <CourseTable />
                    </TabPanel>
                    <TabPanel>
                      <ReferralsTab studentId={estudiante.id} basePath="/plataforma/administrador/ver-estudiante" />
                    </TabPanel>
                    <TabPanel>
                      <StudentRequestsTab student={estudiante} />
                    </TabPanel>
                  </TabPanels>
                )}
              </Tabs>
              <StudentAbsencesModal
                isOpen={isAbsOpen}
                onClose={onAbsClose}
                studentId={id_est}
                gradeId={absFilters.gradeId}
                programTypeId={absFilters.programTypeId}
                programTypeSlug={absFilters.programTypeSlug}
                programName={absFilters.programName}
              />
              <UpdateMonthsModal
                isOpen={isUpdateMonthsModalOpen}
                onClose={closeUpdateMonthsModal}
                studentId={id_est}
                programTypeId={paymentMonthsProgramType}
                programId={paymentMonthsProgram}
                enrollmentId={paymentMonthsEnrollment || undefined}
                preselectedSemesterId={paymentMonthsSemester || undefined}
                programTypes={programTypes}
              />
            </GridItem>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
}

export default VerEstudiante;
